function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import * as aggregations from '../aggregations';
import { getFirstDefined, flattenBy } from '../utils';
import { actions, makePropGetter, ensurePluginOrder, useMountedLayoutEffect, useGetLatest } from '../publicUtils';
var emptyArray = [];
var emptyObject = {}; // Actions

actions.resetGroupBy = 'resetGroupBy';
actions.toggleGroupBy = 'toggleGroupBy';
export var useGroupBy = function useGroupBy(hooks) {
  hooks.getGroupByToggleProps = [defaultGetGroupByToggleProps];
  hooks.stateReducers.push(reducer);
  hooks.visibleColumnsDeps.push(function (deps, _ref) {
    var instance = _ref.instance;
    return [].concat(_toConsumableArray(deps), [instance.state.groupBy]);
  });
  hooks.visibleColumns.push(visibleColumns);
  hooks.useInstance.push(useInstance);
  hooks.prepareRow.push(prepareRow);
};
useGroupBy.pluginName = 'useGroupBy';

var defaultGetGroupByToggleProps = function defaultGetGroupByToggleProps(props, _ref2) {
  var header = _ref2.header;
  return [props, {
    onClick: header.canGroupBy ? function (e) {
      e.persist();
      header.toggleGroupBy();
    } : undefined,
    style: {
      cursor: header.canGroupBy ? 'pointer' : undefined
    },
    title: 'Toggle GroupBy'
  }];
}; // Reducer


function reducer(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _objectSpread({
      groupBy: []
    }, state);
  }

  if (action.type === actions.resetGroupBy) {
    return _objectSpread(_objectSpread({}, state), {}, {
      groupBy: instance.initialState.groupBy || []
    });
  }

  if (action.type === actions.toggleGroupBy) {
    var columnId = action.columnId,
        setGroupBy = action.value;
    var resolvedGroupBy = typeof setGroupBy !== 'undefined' ? setGroupBy : !state.groupBy.includes(columnId);

    if (resolvedGroupBy) {
      return _objectSpread(_objectSpread({}, state), {}, {
        groupBy: [].concat(_toConsumableArray(state.groupBy), [columnId])
      });
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      groupBy: state.groupBy.filter(function (d) {
        return d !== columnId;
      })
    });
  }
}

function visibleColumns(columns, _ref3) {
  var groupBy = _ref3.instance.state.groupBy;
  // Sort grouped columns to the start of the column list
  // before the headers are built
  var groupByColumns = groupBy.map(function (g) {
    return columns.find(function (col) {
      return col.id === g;
    });
  }).filter(Boolean);
  var nonGroupByColumns = columns.filter(function (col) {
    return !groupBy.includes(col.id);
  });
  columns = [].concat(_toConsumableArray(groupByColumns), _toConsumableArray(nonGroupByColumns));
  columns.forEach(function (column) {
    column.isGrouped = groupBy.includes(column.id);
    column.groupedIndex = groupBy.indexOf(column.id);
  });
  return columns;
}

var defaultUserAggregations = {};

function useInstance(instance) {
  var data = instance.data,
      rows = instance.rows,
      flatRows = instance.flatRows,
      rowsById = instance.rowsById,
      allColumns = instance.allColumns,
      flatHeaders = instance.flatHeaders,
      _instance$groupByFn = instance.groupByFn,
      groupByFn = _instance$groupByFn === void 0 ? defaultGroupByFn : _instance$groupByFn,
      manualGroupBy = instance.manualGroupBy,
      _instance$aggregation = instance.aggregations,
      userAggregations = _instance$aggregation === void 0 ? defaultUserAggregations : _instance$aggregation,
      plugins = instance.plugins,
      groupBy = instance.state.groupBy,
      dispatch = instance.dispatch,
      _instance$autoResetGr = instance.autoResetGroupBy,
      autoResetGroupBy = _instance$autoResetGr === void 0 ? true : _instance$autoResetGr,
      disableGroupBy = instance.disableGroupBy,
      defaultCanGroupBy = instance.defaultCanGroupBy,
      getHooks = instance.getHooks;
  ensurePluginOrder(plugins, ['useFilters'], 'useGroupBy');
  var getInstance = useGetLatest(instance);
  allColumns.forEach(function (column) {
    var accessor = column.accessor,
        defaultColumnGroupBy = column.defaultGroupBy,
        columnDisableGroupBy = column.disableGroupBy;
    column.canGroupBy = accessor ? getFirstDefined(column.canGroupBy, columnDisableGroupBy === true ? false : undefined, disableGroupBy === true ? false : undefined, true) : getFirstDefined(column.canGroupBy, defaultColumnGroupBy, defaultCanGroupBy, false);

    if (column.canGroupBy) {
      column.toggleGroupBy = function () {
        return instance.toggleGroupBy(column.id);
      };
    }

    column.Aggregated = column.Aggregated || column.Cell;
  });
  var toggleGroupBy = React.useCallback(function (columnId, value) {
    dispatch({
      type: actions.toggleGroupBy,
      columnId: columnId,
      value: value
    });
  }, [dispatch]);
  flatHeaders.forEach(function (header) {
    header.getGroupByToggleProps = makePropGetter(getHooks().getGroupByToggleProps, {
      instance: getInstance(),
      header: header
    });
  });

  var _React$useMemo = React.useMemo(function () {
    if (manualGroupBy || !groupBy.length) {
      return [rows, flatRows, rowsById, emptyArray, emptyObject, flatRows, rowsById];
    } // Ensure that the list of filtered columns exist


    // Ensure that the list of filtered columns exist
    var existingGroupBy = groupBy.filter(function (g) {
      return allColumns.find(function (col) {
        return col.id === g;
      });
    }); // Find the columns that can or are aggregating
    // Uses each column to aggregate rows into a single value

    // Find the columns that can or are aggregating
    // Uses each column to aggregate rows into a single value
    var aggregateRowsToValues = function aggregateRowsToValues(leafRows, groupedRows, depth) {
      var values = {};
      allColumns.forEach(function (column) {
        // Don't aggregate columns that are in the groupBy
        if (existingGroupBy.includes(column.id)) {
          values[column.id] = groupedRows[0] ? groupedRows[0].values[column.id] : null;
          return;
        } // Get the columnValues to aggregate


        // Get the columnValues to aggregate
        var groupedValues = groupedRows.map(function (row) {
          return row.values[column.id];
        }); // Get the columnValues to aggregate

        // Get the columnValues to aggregate
        var leafValues = leafRows.map(function (row) {
          var columnValue = row.values[column.id];

          if (!depth && column.aggregatedValue) {
            var aggregateValueFn = typeof column.aggregateValue === 'function' ? column.aggregateValue : userAggregations[column.aggregateValue] || aggregations[column.aggregateValue];

            if (!aggregateValueFn) {
              console.info({
                column: column
              });
              throw new Error("React Table: Invalid column.aggregateValue option for column listed above");
            }

            columnValue = aggregateValueFn(columnValue, row, column);
          }

          return columnValue;
        }); // Aggregate the values

        // Aggregate the values
        var aggregateFn = typeof column.aggregate === 'function' ? column.aggregate : userAggregations[column.aggregate] || aggregations[column.aggregate];

        if (aggregateFn) {
          values[column.id] = aggregateFn(leafValues, groupedValues);
        } else if (column.aggregate) {
          console.info({
            column: column
          });
          throw new Error("React Table: Invalid column.aggregate option for column listed above");
        } else {
          values[column.id] = null;
        }
      });
      return values;
    };

    var groupedFlatRows = [];
    var groupedRowsById = {};
    var onlyGroupedFlatRows = [];
    var onlyGroupedRowsById = {};
    var nonGroupedFlatRows = [];
    var nonGroupedRowsById = {}; // Recursively group the data

    // Recursively group the data
    var groupUpRecursively = function groupUpRecursively(rows) {
      var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var parentId = arguments.length > 2 ? arguments[2] : undefined;

      // This is the last level, just return the rows
      if (depth === existingGroupBy.length) {
        return rows;
      }

      var columnId = existingGroupBy[depth]; // Group the rows together for this level

      // Group the rows together for this level
      var rowGroupsMap = groupByFn(rows, columnId); // Peform aggregations for each group

      // Peform aggregations for each group
      var aggregatedGroupedRows = Object.entries(rowGroupsMap).map(function (_ref4, index) {
        var _ref5 = _slicedToArray(_ref4, 2),
            groupByVal = _ref5[0],
            groupedRows = _ref5[1];

        var id = "".concat(columnId, ":").concat(groupByVal);
        id = parentId ? "".concat(parentId, ">").concat(id) : id; // First, Recurse to group sub rows before aggregation

        // First, Recurse to group sub rows before aggregation
        var subRows = groupUpRecursively(groupedRows, depth + 1, id); // Flatten the leaf rows of the rows in this group

        // Flatten the leaf rows of the rows in this group
        var leafRows = depth ? flattenBy(groupedRows, 'leafRows') : groupedRows;
        var values = aggregateRowsToValues(leafRows, groupedRows, depth);
        var row = {
          id: id,
          isGrouped: true,
          groupByID: columnId,
          groupByVal: groupByVal,
          values: values,
          subRows: subRows,
          leafRows: leafRows,
          depth: depth,
          index: index
        };
        subRows.forEach(function (subRow) {
          groupedFlatRows.push(subRow);
          groupedRowsById[subRow.id] = subRow;

          if (subRow.isGrouped) {
            onlyGroupedFlatRows.push(subRow);
            onlyGroupedRowsById[subRow.id] = subRow;
          } else {
            nonGroupedFlatRows.push(subRow);
            nonGroupedRowsById[subRow.id] = subRow;
          }
        });
        return row;
      });
      return aggregatedGroupedRows;
    };

    var groupedRows = groupUpRecursively(rows);
    groupedRows.forEach(function (subRow) {
      groupedFlatRows.push(subRow);
      groupedRowsById[subRow.id] = subRow;

      if (subRow.isGrouped) {
        onlyGroupedFlatRows.push(subRow);
        onlyGroupedRowsById[subRow.id] = subRow;
      } else {
        nonGroupedFlatRows.push(subRow);
        nonGroupedRowsById[subRow.id] = subRow;
      }
    }); // Assign the new data

    // Assign the new data
    return [groupedRows, groupedFlatRows, groupedRowsById, onlyGroupedFlatRows, onlyGroupedRowsById, nonGroupedFlatRows, nonGroupedRowsById];
  }, [manualGroupBy, groupBy, rows, flatRows, rowsById, allColumns, userAggregations, groupByFn]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 7),
      groupedRows = _React$useMemo2[0],
      groupedFlatRows = _React$useMemo2[1],
      groupedRowsById = _React$useMemo2[2],
      onlyGroupedFlatRows = _React$useMemo2[3],
      onlyGroupedRowsById = _React$useMemo2[4],
      nonGroupedFlatRows = _React$useMemo2[5],
      nonGroupedRowsById = _React$useMemo2[6];

  var getAutoResetGroupBy = useGetLatest(autoResetGroupBy);
  useMountedLayoutEffect(function () {
    if (getAutoResetGroupBy()) {
      dispatch({
        type: actions.resetGroupBy
      });
    }
  }, [dispatch, manualGroupBy ? null : data]);
  Object.assign(instance, {
    preGroupedRows: rows,
    preGroupedFlatRow: flatRows,
    preGroupedRowsById: rowsById,
    groupedRows: groupedRows,
    groupedFlatRows: groupedFlatRows,
    groupedRowsById: groupedRowsById,
    onlyGroupedFlatRows: onlyGroupedFlatRows,
    onlyGroupedRowsById: onlyGroupedRowsById,
    nonGroupedFlatRows: nonGroupedFlatRows,
    nonGroupedRowsById: nonGroupedRowsById,
    rows: groupedRows,
    flatRows: groupedFlatRows,
    rowsById: groupedRowsById,
    toggleGroupBy: toggleGroupBy
  });
}

function prepareRow(row) {
  row.allCells.forEach(function (cell) {
    // Grouped cells are in the groupBy and the pivot cell for the row
    cell.isGrouped = cell.column.isGrouped && cell.column.id === row.groupByID; // Placeholder cells are any columns in the groupBy that are not grouped

    cell.isPlaceholder = !cell.isGrouped && cell.column.isGrouped; // Aggregated cells are not grouped, not repeated, but still have subRows

    cell.isAggregated = !cell.isGrouped && !cell.isPlaceholder && row.canExpand;
  });
}

export function defaultGroupByFn(rows, columnId) {
  return rows.reduce(function (prev, row, i) {
    // TODO: Might want to implement a key serializer here so
    // irregular column values can still be grouped if needed?
    var resKey = "".concat(row.values[columnId]);
    prev[resKey] = Array.isArray(prev[resKey]) ? prev[resKey] : [];
    prev[resKey].push(row);
    return prev;
  }, {});
}